angular.module('gym.mobile_app').factory('LoadDebounceMobileAppMetaService', ["$q", "MobileApp", function($q, MobileApp) {
  var loadDebounced;
  loadDebounced = _.debounce((function(deferred) {
    return MobileApp.all('settings').doGET('meta').then(function(data) {
      return deferred.resolve(data.plain());
    }, function(data) {
      return deferred.reject(data);
    });
  }), 1000);
  return {
    load: function() {
      var deferred;
      deferred = $q.defer();
      loadDebounced(deferred);
      return deferred.promise;
    }
  };
}]);
